<!-- LIST VIEW -->
@if (mode === 'list') {
  <div class="card">
    <div class="row mb-2">
      <div class="col-8 align-self-center">
        <h3 class="card-title">{{ 'title.product-leaflets' | translate }}</h3>
      </div>
      <div class="col-4 d-flex flex-row-reverse">
        @if (productDetailService.hasRoleLeafletsCreate) {
          <btn [label]="'add'" [icon]="'far-plus'" [classes]="['btn-first']" (onEvent)="startCreate()"></btn>
        }
      </div>
    </div>
    <loading-spinner [isLoading]="listLoading"></loading-spinner>
    @if (!listLoading && !leaflets?.length) {
      <div class="d-flex justify-content-center p-3">
        {{ 'no.items' | translate }}
      </div>
    }
    @if (!listLoading && leaflets?.length) {
      <div class="table-responsive">
        <table class="table">
          <thead>
            <tr>
              <!--          <th>ID</th>-->
              <th>{{ 'text' | translate }}</th>
              <th>{{ 'product.shippingCountry' | translate }}</th>
              <th class="text-end">{{ 'code.width' | translate }} (mm)</th>
              <th class="text-end">{{ 'code.height' | translate }} (mm)</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            @for (lf of leaflets; track lf) {
              <tr>
                <!--          <td>{{ lf.id }}</td>-->
                <td class="leaflet-text-html" [innerHTML]="lf.text"></td>
                <td>
                  @for (c of lf.countries; track c) {
                    <span class="badge bg-secondary me-1">{{ getCountryName(c) }}</span>
                  }
                </td>
                <td class="text-end">{{ lf.width }}</td>
                <td class="text-end">{{ lf.height }}</td>
                <td class="text-end text-nowrap">
                  @if (productDetailService.hasRoleLeafletsUpdate) {
                    <btn [icon]="'far-pencil'" [classes]="['btn-sm', 'btn-edit']" (onEvent)="startEdit(lf)"></btn>
                  }
                  @if (productDetailService.hasRoleLeafletsDelete) {
                    <btn
                      [icon]="'far-trash-alt'"
                      [classes]="['btn-sm', 'btn-trash']"
                      (onEvent)="deleteLeaflet(lf)"
                    ></btn>
                  }
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    }
  </div>
}

<!-- CREATE / EDIT VIEW -->
@if (mode !== 'list') {
  <div class="row">
    <div class="col-12 mb-2">
      <btn
        [label]="'back.leaflets-list'"
        [classes]="['btn-third']"
        [icon]="'far-arrow-left'"
        (onEvent)="mode = 'list'"
      ></btn>
    </div>
    <div class="col-4">
      <div class="card">
        <div class="mb-3">
          <label class="d-flex justify-content-between">{{ 'text' | translate }}</label>
          @if (ckeditor && ckeditorConfig) {
            <ckeditor
              class="mb-3"
              [editor]="ckeditor"
              [config]="ckeditorConfig"
              [(ngModel)]="text"
              [ngModelOptions]="{ standalone: true }"
              (ngModelChange)="onSettingChange()"
              data-cy="leaflet-text"
            ></ckeditor>
          } @else {
            @if (ckeditorLoading) {
              <div class="ckeditor-placeholder mb-3" aria-hidden="true"></div>
            }
            @if (ckeditorLoadError) {
              <textarea
                class="form-control ckeditor-fallback mb-3"
                rows="4"
                [(ngModel)]="text"
                [ngModelOptions]="{ standalone: true }"
                (ngModelChange)="onSettingChange()"
                data-cy="leaflet-text"
              ></textarea>
            }
          }
          <form-row-select-multiple
            [label]="'product.shippingCountry'"
            [options]="countries"
            [selectedValues]="selectedCountries"
            (selectedValuesChange)="setCountries($event)"
          ></form-row-select-multiple>
          <!--        <div class="d-flex flex-column gap-2">-->
          <div class="d-flex">
            <form-row-input
              [label]="'code.width'"
              [inputType]="'number'"
              [appendUnitCustom]="'mm'"
              [(model)]="ticketWidthMm"
              (modelChange)="onSettingChange()"
            ></form-row-input>
            <form-row-input
              [label]="'code.height'"
              [inputType]="'number'"
              [appendUnitCustom]="'mm'"
              [model]="ticketHeightMm"
              (modelChange)="onHeightChange($event)"
            ></form-row-input>
          </div>
        </div>
        <div class="d-flex justify-content-between">
          <btn [label]="'back'" [classes]="['btn-third']" [icon]="'far-arrow-left'" (onEvent)="mode = 'list'"></btn>
          <div class="d-flex flex-gap-10">
            <btn [label]="'print'" [classes]="['btn-third']" (onEvent)="confirmPreview()"></btn>
            @if (mode === 'create') {
              <btn [label]="'save'" [classes]="['btn-first']" (onEvent)="createLeaflet()"></btn>
            }
            @if (mode === 'edit') {
              <btn [label]="'save'" [classes]="['btn-first']" (onEvent)="updateLeaflet()"></btn>
            }
          </div>
        </div>
      </div>
    </div>
    <div class="col-8 ps-2 pe-5">
      <div>
        <ng-template #ticketTemplate let-ticketData="ticketData">
          <div
            class="print-label-outline"
            #printable
            [style.width.mm]="ticketWidthMm"
            [style.height]="cssHeight"
            [style.min-height]="cssMinHeight"
            [style.padding-left.mm]="barcodePaddingHorizontalMm"
            [style.padding-right.mm]="barcodePaddingHorizontalMm"
            [style.padding-top.mm]="barcodePaddingVerticalMm"
            [style.padding-bottom.mm]="barcodePaddingVerticalMm"
          >
            @if (codeType === 'qr') {
              <div>
                <div
                  class="print-label-container print-label-container-qrcode"
                  [style.width.mm]="ticketWidthMm"
                  [style.height]="cssHeight"
                  [style.min-height]="cssMinHeight"
                  [style.margin-top.mm]="pageMarginTopMm"
                  [style.margin-left.mm]="pageMarginLeftMm"
                >
                  @if (ticketData.base64 && ticketData.base64.length > 0) {
                    <img
                      [src]="ticketData.base64"
                      alt=""
                      class="qr-code"
                      [style.height]="qrHeightMm > 0 ? qrHeightMm + 'mm' : '100%'"
                    />
                  }
                  <div
                    class="print-2nd-col text-center"
                    [style.padding-top.mm]="effectiveHeightMm / 20"
                    [style.padding-bottom.mm]="effectiveHeightMm / 20"
                    [style.margin-left.mm]="ticketWidthMm / 30"
                  >
                    <div class="font-weight-bold" [style.font-size.mm]="(effectiveHeightMm / 5) * textSizeMultiplier">
                      {{ isBarcodeTitleVisible ? ticketData.labelTitle || ticketData.text : '&nbsp;' }}
                    </div>
                    <div [style.font-size.mm]="(effectiveHeightMm / 6) * textSizeMultiplier">
                      {{ isBarcodeEanVisible ? ticketData.labelEan : '&nbsp;' }}
                    </div>
                    <!-- Live Leaflet text preview -->
                    <div
                      [style.font-size.mm]="textFontSizeMm"
                      class="mt-1 leaflet-text-html"
                      [innerHTML]="ticketData.text"
                    ></div>
                    <!-- Live countries preview as a single line (bigger font) -->
                    <div class="mt-1" [style.font-size.mm]="textFontSizeMm">
                      {{ ticketData.countriesLine }}
                    </div>
                    <div [style.font-size.mm]="(effectiveHeightMm / 6) * textSizeMultiplier">
                      {{ isGS1 && isGS1BatchVisible && customBatch?.length > 0 ? 'Šarže: ' + customBatch : '' }}
                    </div>
                    <div [style.font-size.mm]="(effectiveHeightMm / 6) * textSizeMultiplier">
                      {{
                        isGS1 && isGS1ExpirationDateVisible && customExpirationDate?.length > 0
                          ? 'Expirace: ' + (customExpirationDate | fmtDate: 'dd.MM.yyyy')
                          : ''
                      }}
                    </div>
                    <div
                      class="text-end"
                      [style.padding-top.mm]="effectiveHeightMm / 10"
                      [style.font-size.mm]="(effectiveHeightMm / 6) * textSizeMultiplier"
                    >
                      {{ isBarcodePriceVisible ? ticketData.labelPrice : '&nbsp;' }}
                    </div>
                  </div>
                </div>
              </div>
            }
            <!-- Leaflet text-only preview (no QR/Barcode) -->
            @if (codeType === 'leaflet') {
              <div>
                <div
                  class="print-label-container"
                  [style.width.mm]="ticketWidthMm"
                  [style.height]="cssHeight"
                  [style.min-height]="cssMinHeight"
                  [style.margin-top.mm]="pageMarginTopMm"
                  [style.margin-left.mm]="pageMarginLeftMm"
                >
                  <div
                    class="print-2nd-col text-center"
                    [style.padding-top.mm]="effectiveHeightMm / 10"
                    [style.padding-bottom.mm]="effectiveHeightMm / 20"
                  >
                    <!-- Main leaflet text -->
                    <div
                      class="font-weight-bold leaflet-text-html"
                      [style.font-size.mm]="textFontSizeMm"
                      [innerHTML]="ticketData.text"
                    ></div>
                    <!-- Countries as a single descriptive line (bigger font) -->
                    <div class="mt-1" [style.font-size.mm]="textFontSizeMm">
                      {{ ticketData.countriesLine }}
                    </div>
                  </div>
                </div>
              </div>
            }
            @if (codeType === 'barcode') {
              <div>
                <div
                  class="print-label-container print-label-container-barcode"
                  [style.width.mm]="ticketWidthMm"
                  [style.height]="cssHeight"
                  [style.min-height]="cssMinHeight"
                  [style.margin-top.mm]="pageMarginTopMm"
                  [style.margin-left.mm]="pageMarginLeftMm"
                >
                  @if (ticketData.base64 && ticketData.base64.length > 0) {
                    <img [src]="ticketData.base64" alt="" class="bar-code" />
                  }
                  <div
                    class="print-2nd-col text-center"
                    [style.padding-left.mm]="ticketWidthMm / 25"
                    [style.padding-right.mm]="ticketWidthMm / 25"
                  >
                    <div class="font-weight-bold" [style.font-size.mm]="(effectiveHeightMm / 5) * textSizeMultiplier">
                      {{ isBarcodeTitleVisible ? ticketData.labelTitle || ticketData.text : '&nbsp;' }}
                    </div>
                    <div class="print-2nd-row">
                      <div [style.font-size.mm]="(effectiveHeightMm / 6) * textSizeMultiplier">
                        {{ isBarcodeEanVisible ? ticketData.labelEan : '&nbsp;' }}
                      </div>
                      <div class="text-end" [style.font-size.mm]="(effectiveHeightMm / 6) * textSizeMultiplier">
                        {{ isBarcodePriceVisible ? ticketData.labelPrice : '&nbsp;' }}
                      </div>
                    </div>
                    <!-- Live Leaflet text and countries -->
                    <div
                      [style.font-size.mm]="textFontSizeMm"
                      class="mt-1 leaflet-text-html"
                      [innerHTML]="ticketData.text"
                    ></div>
                    <div class="mt-1" [style.font-size.mm]="textFontSizeMm">
                      {{ ticketData.countriesLine }}
                    </div>
                  </div>
                </div>
              </div>
            }
          </div>
        </ng-template>
        <div
          class="pageCard"
          #pageCard
          [style.width]="'calc(' + (ticketWidthMm + barcodePaddingHorizontalMm * 2) + 'mm + 40px)'"
        >
          <ng-container
            [ngTemplateOutlet]="ticketTemplate"
            [ngTemplateOutletContext]="{ ticketData: singleTicketDataWithNames() }"
          >
          </ng-container>
        </div>
      </div>
      <div class="invisible">
        <canvas #barcode id="barcode"></canvas>
      </div>
    </div>
  </div>
}
